import type { BookableClassFragment, ClassType } from '@lingoda/monolith-graphql';

export * from './classesVars';
export * from './leadTime';
export * from './sectionLeadTime';
export * from './bookClassEvent';

export enum BookingView {
    Grid = 'grid',
    List = 'list',
}

export interface BookingFilter {
    readonly timeSlots: {
        readonly slots: number[];
        readonly extendHours: number;
    };
    readonly classType: ClassType;
    readonly modules: number[];
    readonly lessons: number[];
    readonly dates: Date[];
}

export interface BookableClass extends Omit<BookableClassFragment, 'startDate'> {
    startDate: Date;
}
